import React, { Component, Suspense } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { Route, Router } from 'react-router-dom';
//import {PrivateRoute} from '../../components/HelperComponents/PrivateRoute';
import { createBrowserHistory } from "history";
import * as authActions from "./../../actions/authActions";
const customHistory = createBrowserHistory();
//import { isLoaded as isAuthLoaded, load as loadAuth } from '../../redux/modules/auth';

const Root = React.lazy(() => import('../Root/RootContainer'));
const Login = React.lazy(() => import('../Login/Login'));
const NotFound = React.lazy(() => import('../NotFound/index'));
const ModalPopoutComponent = React.lazy(() => import('../ModalPopout/ModalPopoutComponent'));
const BackbuttonComponent = React.lazy(() => import('../BackButtonComponent/BackButtonModal'));
const SessionExpModalComponent = React.lazy(() => import('../Modal/SessionExpModalComponent'));
const TradePanel = React.lazy(() => import('../TradePanel/TradePanelComponent'));

import 'bootstrap/dist/css/bootstrap.min.css';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import 'font-awesome/css/font-awesome.min.css';
import '../../styles/styles.css';
import '../../styles/daterangepicker.css';
import styles from './App.less';
import '../../theme/styles/calendar.css'
import '../../theme/styles/mediaqueries.css';

@connect(null, { ...authActions })

class App extends Component {
  constructor(props) {
    super(props);
  }
  static propTypes = {
    isAuthLoaded: PropTypes.isLoaded,
    loadAuth: PropTypes.load
  }

  requireLogin = (nextState, replace, cb) => {
    function checkAuth() {
      const user = localStorage.getItem('user');
      if (!user) {
        replace('/login');
      }
      cb();
    }
    if (!isAuthLoaded(store.getState())) {
      store.dispatch(loadAuth());
      checkAuth();
    } else {
      checkAuth();
    }
  };

  render() {
    return (
      <Suspense fallback={
        <div id="content" class='contentOverlay'>
          <div className="loadingio-spinnerdiv loadingio-spinner-rolling-bsictdkru1">
            <div className="lodingSpinner">
              <div></div>
            </div>
          </div>
        </div>}>
        <Router history={customHistory}>
          <div>
            <Route exact path="/login" component={Login} />
            <Route exact path="/" component={Login} />
            <div className={styles.appContent}>
              <main>
                <Route onEnter={this.requireLogin}>
                  <Route exact path="/home" component={Root} />
                  <Route path="/trade" component={TradePanel} />
                </Route>
              </main>
            </div>
            <Route path="/session_expired" component={SessionExpModalComponent} />
            <Route path="/backbutton" component={BackbuttonComponent} />
            <Route path="/alreadyLoggedin" component={SessionExpModalComponent} />
            <Route path="/popoutRefresh" component={ModalPopoutComponent} />
          </div>
        </Router>
      </Suspense>
    );
  }
}

export default App;

